import { atom, selector } from "recoil";
import { createDataRequest, updateDataRequest, createNoteRequest, getArrivalFlightListRequest, getDepartureFlightListRequest } from "../../../api/controller/TransferBagController";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";

export const transferBagListState = atom({
    key: 'transferBagListState',
    default: [],
})
export const transferBagFromFlightState = atom({
	key: 'transferBagFromFlightState',
	default:{
		data:[],
		ovf:false,
	}
})
export const transferBagToFlightState = atom({
	key: 'transferBagToFlightState',
	default:{
		data:[],
		ovf:false,
	}
})


export const modalConfigDefault = { size: "lg", wizard: false }

export const filtersDefault = []

export const formModes = {
    create: [ { name: 'Default Create', action: createDataRequest } ], 
    update: [ { name: 'Default Update', action: updateDataRequest }, { name: 'Create Note', action: createNoteRequest, closeOnSubmit: true } ],
    view: [ { name: 'Default View' } ],
}

export const transferBagDataStructureState = selector({
    key: 'transferBagDataStructureState',
    get: ({ get }) => (
        [

            { 
                label: 'From Flight Date',
                type: 'datepicker',
                order: { table: 1, form: 1 }, 
				table: { dateFormat: 'MMM Do, YYYY', postDateFormat:'YYYY-MM-DD' },
                create: [{ enabled: true, size: { xs: 12, md: 6 } , dateFormat: 'YYYY-MM-DD', options: { altInput: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d' } }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
                child: {
                    name: "FromFlight",
                    subFields: { label: "name", value: "name" }, 
                    fn: getArrivalFlightListRequest
                }
            },
			{ 
                label: 'From Flight',
                type: 'select',
                rootValue: true,
                order: { table: 2, form: 2 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'disabled_if:FromFlightDate,null' }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
                list: get(transferBagFromFlightState),
            },
			{ 
                label: 'To Flight Date',
                type: 'datepicker',
                order: { table: 3, form: 3 }, 
				table: { dateFormat: 'MMM Do, YYYY', postDateFormat:'YYYY-MM-DD' },
                create: [{ enabled: true, size: { xs: 12, md: 6 } , dateFormat: 'YYYY-MM-DD', options: { altInput: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d' } }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
                child: {
                    name: "ToFlight",
                    subFields: { label: "name", value: "name" }, 
                    fn: getDepartureFlightListRequest
                }
            },
			{ 
                label: 'To Flight',
                type: 'select',
                rootValue: true,
                order: { table: 4, form: 4 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'disabled_if:ToFlightDate,null' }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
                list: get(transferBagToFlightState),
            },
			{ 
                label: 'Total Bags',
                type: 'number',
                order: { table: 5, form: 5 }, 
                create: [{ enabled: true, size: { xs: 12, md: 4 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Bags Received',
                type: 'number',
                order: { table: 6, form: 6 }, 
                create: [{ enabled: true, size: { xs: 12, md: 4 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Bags Connected',
                type: 'number',
                order: { form: 7 }, 
                create: [{ enabled: true, size: { xs: 12, md: 4 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Tag Numbers',
                type: 'text',
                order: { form: 8 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },

            
			{ 
                label: 'Notes',
                type: 'repeater',
                order: { form: 10 },
                create: [{ enabled: false }], update: [{ enabled: false }, { enabled: false }], view: [{ enabled: true, size: { xs: 12, md: 12, lg: 12 }, deleteBtnSize: { xs: 2, md: 1 }, repeatLabel: true, divider: true }],
                children: [
                    { 
                		label: 'Note',
                		type: 'text',
                		order: { form: 1 }, 
                		create: [{ enabled: false }], update: [{ enabled: false }, { enabled: false }], view: [{ enabled: true, size: { xs: 12, md: 6, lg: 8 }  }], 
            		},
                    { 
                		label: 'User',
                		type: 'select',
                		order: { form: 2 }, 
                		create: [{ enabled: false }], update: [{ enabled: false }, { enabled: false }], view: [{ enabled: true, size: { xs: 12, md: 3, lg: 2 }  }], 
            		},
                    { 
                		label: 'Time',
                		type: 'datepicker',
						field: 'created_at',
                		order: { form: 3 }, 
                		create: [{ enabled: false }], update: [{ enabled: false }, { enabled: false }], view: [{ enabled: true, size: { xs: 12, md: 3, lg: 2 }, dateFormat: 'MMM Do, HH:mm' }], 
            		},
				]
			},

			{
				label: 'Note',
				type: 'textarea',
				order: { form: 10.1 }, 
				create: [{ enabled: false }], 
				update: [
					'same_as:create.0',
					{ enabled: true, size: { xs: 12 } },
				], 
				view: ['same_as:create.0'],
            },

        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
